import { Settings } from './settings';

export class Utilities {
  public static EXP_REG_SOLO_LETRAS_Y_ESPACIOS = /^[a-zA-ZñÑáÁéÉíÍóÓúÚ\s]*$/;
  public static EXP_REG_SOLO_NUMEROS = /^[0-9]*$/;
  public static EXP_REG_SOLO_NUMEROS_Y_COMAS = /^[0-9,]*$/;
  public static EXP_REG_NUMERICO_LARGO_8 = /^\d{8}$/;
  public static EXP_REG_FORMATO_EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  public static EXP_REG_FORMATO_CHIP = /^\d\d\d\s\d\d\d\d\s\d\d\d\d$/;
  public static EXP_REG_FORMATO_ABONADO = /^[0-9]*$/;
  public static EXP_REG_FORMATO_SMART_CARD = /^\d\d\d\s\d\d\d\d\s\d\d\d\d\s[-]\s\d$/;

  public static log(toLog: any): void {
    if (Settings.debug) {
      console.log(toLog);
    }
  }

  public static logError(toLog: any): void {
    if (Settings.showErrorsInConsole) {
      console.error(toLog);
    }
  }

  public static dateValidation(dateToValidate: string, dateDescription: string, minimumDate?: string): any {
    const result = {
      hasError: false,
      dateIsValid: true,
      errors: []
    };

    const dateToValidateDateFormat = new Date(dateToValidate).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);

    if (today <= dateToValidateDateFormat) {
      result.dateIsValid = false;
      result.errors.push(`No puede ingresar una ${dateDescription} superior a la actual.`);
    }

    if (minimumDate) {
      const minimumDateDateFormat = new Date(minimumDate).setHours(0, 0, 0, 0);
      if (minimumDateDateFormat > dateToValidateDateFormat) {
        result.dateIsValid = false;
        result.errors.push(`No puede ingresar una ${dateDescription} inferior a ${minimumDate}.`);
      }
    }

    return result;
  }
}
